import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom"; 
import { X } from 'lucide-react';
import "./Myaccount.css";
import Loading1 from "../loading_animation/loading";
import { PDFDocument, StandardFonts, rgb } from "pdf-lib";
import AssignmentSubmit from "./assignments";
import { useLocation } from "react-router-dom";

const Dashboard = () => {
  const [username, setUsername] = useState("");
  const [loading, setLoading] = useState(true);
  const [config, setConfig] = useState(null);
  const [activeTab, setActiveTab] = useState("address");
  const [canAccessInternship, setCanAccessInternship] = useState(false);
  const [internshipDetails, setInternshipDetails] = useState(null);
  const [amount, setAmount] = useState(0); 
  const [paymentDone, setPaymentDone] = useState(false);
  const [slotDetails, setSlotDetails] = useState(null);
  const [userEmail, setUserEmail] = useState("");
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);
  const [message, setMessage] = useState(null);
  const [transactionId, setTransactionId] = useState("");
  const [showQR, setShowQR] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [hasApplied, setHasApplied] = useState(false);
  const [isCompleted, setIsCompleted] = useState(false);
  const location = useLocation();

  
  const navigate = useNavigate();

  const [addresses, setAddresses] = useState({ address1: null, address2: null });
  const [editingAddress, setEditingAddress] = useState(null);
  const [formData, setFormData] = useState({
    fullname: "",
    mobile: "",
    pincode: "",
    flat: "",
    area: "",
    landmark: "",
    city: "",
    state: "",
    default: false,
    instructions: "",
  });

  const [formErrors, setFormErrors] = useState({
  fullname: "",
  mobile: "",
  pincode: "",
  flat: "",
  area: "",
  landmark: "",
  city: "",
  state: "",
  instructions: "",
});


useEffect(() => {
  if (location.state?.openTab) {
    setActiveTab(location.state.openTab);
  }
}, [location.state]);

  useEffect(() => {
    fetch("/config.json")
      .then(res => res.json())
      .then(data => setConfig(data))
      .catch(err => console.error("Error loading config:", err));
  }, []);

   useEffect(() => {
      if (message) {
        const timer = setTimeout(() => setMessage(null), 5000);
        return () => clearTimeout(timer);
      }
    }, [message]);
  

  const validateField = (name, value) => {
  let error = "";

  switch (name) {
    case "fullname":
      if (!value.trim()) error = "Full name is required";
      else if (!/^[A-Za-z\s]+$/.test(value)) error = "Full name should contain only letters";
      break;
    case "mobile":
      if (!/^\d{10}$/.test(value)) error = "Enter a valid 10-digit mobile number";
      break;
    case "pincode":
      if (!/^\d{6}$/.test(value)) error = "Enter a valid 6-digit pincode";
      break;
    case "flat":
      if (!value.trim()) error = "Flat/House No. is required";
      break;
    case "area":
      if (!value.trim()) error = "Area/Street is required";
      break;
    case "landmark":
      if (!value.trim()) error = "Landmark is required";
      break;
    case "city":
      if (!value.trim()) error = "City is required";
      break;
    case "state":
      if (!value.trim()) error = "State is required";
      break;
    case "instructions":
      if (!value.trim()) error = "Delivery instructions are required";
      break;
    default:
      break;
  }

  setFormErrors(prev => ({ ...prev, [name]: error }));
};


  useEffect(() => {
    if (!config) return;

    const fetchUserData = async () => {
      try {
        const res = await fetch(`${config.BASE_URL}${config.USER_INFO}`, {
          method: "POST",
          credentials: "include",
          headers: { "Content-Type": "application/json" },
        });
        const data = await res.json();
        if (data.success) {
          setUsername(data.fullname);
           setUserEmail(data.email);
          setAddresses({
            address1: data.address1 || null,
            address2: data.address2 || null,
          });
        }
      } catch (err) {
        console.error("Fetch error:", err);
      } finally {
        setLoading(false);
      }

      try {
        const res2 = await fetch(`${config.BASE_URL}${config.CHECK_INTERNSHIP}`, {
          method: "POST",
          credentials: "include",
        });
        const data2 = await res2.json();
        //console.log(data2);
        if (data2.success) {
          setCanAccessInternship(data2.approved);
          if (data2.applications && data2.applications.length > 0) {
            const details = data2.applications[0];
            details.intern_id = details.application_id;
            setAmount(details.amount || 0); 
            setInternshipDetails(details); 
          }
        }
      } catch (err) {
        console.error("Error checking internship:", err);
      }
    };

    fetchUserData();
  }, [config]);

      useEffect(() => {
    if (!config) return;
  
    const checkApplication = async () => {
      try {
        const res = await fetch(`${config.BASE_URL}${config.CHECK_APPLICATION_STATUS}`, {
          method: "POST",
          credentials: "include",
        });
  
        const data = await res.json();
  
        if (data.success) {
          setHasApplied(true);
        } else {
          setHasApplied(false);
        }
      } catch (e) {
        console.error("Error checking status:", e);
      }
    };
  
    checkApplication();
  }, [config]);


useEffect(() => {
  if (!config) return;

  const fetchLatestApplication = async () => {
    try {
      const res = await fetch(`${config.BASE_URL}${config.INTERNSHIP_COMPLETION_STATUS}`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
      });

      const data = await res.json();
      //console.log(data);
      if (data.success && data.application) {
        setIsCompleted(Boolean(data.application.completed_status));
      } else {
        setIsCompleted(false);
      }
    } catch (err) {
      console.error("Error fetching latest application status:", err);
      setIsCompleted(false);
    }
  };

  fetchLatestApplication();
  
}, [config]);

  const handlePaymentConfirmation = async () => {
  if (transactionId.trim() === "") {
    setMessage("Please enter the transaction ID");
    return;
  }
  setIsLoading(true);
  try {
    const res = await fetch(`${config.BASE_URL}${config.SUBMIT_PAYMENT}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify({
        intern_id: internshipDetails.intern_id,
        name: internshipDetails.name,
        domain: internshipDetails.domain,
        amount: amount,
        transaction_id: transactionId
      }),
    });

    const data = await res.json();

    if (data.status) {
      setMessage("Payment verified successfully!");
      setShowQR(false);
      setPaymentDone(true);
    } else {
      setMessage("Invalid Transaction ID");
    }
  } catch (err) {
    console.error(err);
    setMessage("Something went wrong");
  }finally {
      setIsLoading(false);
    }
};


const handleDownloadCertificate = async (intern_id) => {
  try {
    
    const detailsResponse = await fetch(
      `${config.BASE_URL}${config.GET_CERTIFICATE_DETAILS}`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ intern_id }),
      }
    );

    const detailsData = await detailsResponse.json();

    if (!detailsData.success) {
      alert("Unable to fetch intern details");
      return;
    }

    const intern = detailsData.data;

    // Fetch template file name
    const templateResponse = await fetch(
      `${config.BASE_URL}${config.GENERATE_PDF}`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" }
      }
    );

    const templateData = await templateResponse.json();

    if (!templateData.success) {
      alert("Error fetching template");
      return;
    }

    const templateUrl = `/Templates/${templateData.fileName}`;

    // Load template PDF
    const templateBytes = await fetch(templateUrl).then((res) =>
      res.arrayBuffer()
    );

    const pdfDoc = await PDFDocument.load(templateBytes);

    const page = pdfDoc.getPage(0);
    const font = await pdfDoc.embedFont(StandardFonts.Helvetica);
// Colors
const blue =  rgb(0.121, 0.219, 0.549);    
const green = rgb(0, 0.55, 0);        
const black = rgb(0, 0, 0);           
const white = rgb(1, 1, 1);           


const reverseDate = (dateStr) => {
  if (!dateStr) return "";
  const [year, month, day] = dateStr.split("-");
  return `${day}-${month}-${year}`;
};

const startDate = reverseDate(intern.internship_start_date);
const endDate   = reverseDate(intern.internship_end_date);

// Prefix + UPPERCASE name
const prefix = "Mr/Ms. ";
const displayName = `${prefix}${intern.name.toUpperCase()}`;
const domainUpper = intern.domain.toUpperCase();

// ---------------------------
// AUTO SIZE FUNCTION
// ---------------------------
const autoSizeCenter = (text, maxSize, minSize, maxWidth) => {
  let size = maxSize;
  let width = font.widthOfTextAtSize(text, size);

  while (width > maxWidth && size > minSize) {
    size -= 1;
    width = font.widthOfTextAtSize(text, size);
  }

  const x = (page.getWidth() - width) / 2;
  return { size, x };
};

// Max printable width:
const printableWidth = page.getWidth() - 80; 

// ---------------------------
// AUTO-ADJUST NAME
// ---------------------------
const nameFit = autoSizeCenter(displayName, 30, 14, printableWidth);

page.drawText(displayName, {
  x: nameFit.x,
  y: 510,
  size: nameFit.size,
  font,
  color: blue,
});

// ---------------------------
// AUTO-ADJUST DOMAIN
// ---------------------------
const domainFit = autoSizeCenter(domainUpper, 30, 14, printableWidth);

page.drawText(domainUpper, {
  x: domainFit.x,
  y: 440,
  size: domainFit.size,
  font,
  color: green,
});

// ---------------------------
// DATES (fixed size & positions)
// ---------------------------
page.drawText(startDate, {
  x: 180,
  y: 358,
  size: 17,
  font,
  color: black,
});

page.drawText(endDate, {
  x: 406,
  y: 358,
  size: 17,
  font,
  color: black,
});

// ---------------------------
// INTERN ID
// ---------------------------
page.drawText(intern.intern_id, {
  x: 66,
  y: 120,
  size: 17,
  font,
  color: white,
});


    
    const pdfBytes = await pdfDoc.save();

    const blob = new Blob([pdfBytes], { type: "application/pdf" });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = `${intern.name}_Certificate.pdf`;
    a.click();
    window.URL.revokeObjectURL(url);

  } catch (error) {
    console.error("Certificate generation failed:", error);
    alert("Certificate download failed");
  }
};



    const handleLogout = async () => {
    if (!config) return;
    try {
      const res = await fetch(`${config.BASE_URL}${config.USER_LOGOUT}`, {
        method: "POST",
        credentials: "include",
      });
      const data = await res.json();
      if (data.status) {
        setMessage("Logged out successfully");
        navigate("/"); 
      } else {
        setMessage("Logout failed");
      }
    } catch (err) {
      console.error("Logout error:", err);
      setMessage("Error logging out");
    }
  };

  useEffect(() => {
    if (activeTab === "internship" && config) {
      checkSlot();
    }
  }, [activeTab, config]);

  const handleChange = (e) => {
  const { name, value, type, checked } = e.target;
  const fieldValue = type === "checkbox" ? checked : value;
  setFormData({ ...formData, [name]: fieldValue });
  validateField(name, fieldValue); 
};


  const handleSave = async (e) => {
    e.preventDefault();

  const requiredFields = [
  "fullname",
  "mobile",
  "pincode",
  "flat",
  "area",
  "landmark",
  "city",
  "state",
  "instructions",
];

  const hasEmpty = requiredFields.some(f => !formData[f].trim());
  if (hasEmpty) {
    setMessage("Please fill all required fields.");
    return;
  }

     const hasErrors = Object.values(formErrors).some(err => err);
  if (hasErrors) {
    setMessage("Please fix the errors before saving.");
    return;
  }
    const slot = editingAddress === 1 ? "address1" : "address2";
    const payload = { ...formData, slot };
    try {
      const res = await fetch(`${config.BASE_URL}${config.SAVE_ADDRESS}`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      const data = await res.json();
      if (data.success) {
        setAddresses({ ...addresses, [slot]: data.address });
        setEditingAddress(null);
      } else {
        setMessage(data.message || "Failed to save address");
      }
    } catch (err) {
      console.error("Save error:", err);
    }
  };

  const handlePayment = async () => {
    if (!config) return;
    try {
      const amountInPaise = Math.round(amount * 100);

      const response = await fetch(`${config.BASE_URL}${config.CREATE_ORDER}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ amount: amountInPaise }),
      });

      const data = await response.json();
      const { order_id } = data;

      if (!order_id) {
        setMessage("Failed to create Razorpay order");
        return;
      }

      const options = {
        key: "rzp_live_1P7gGwYcHvQ4oz",
        amount: amountInPaise,
        currency: "INR",
        name: "Robocoupler",
        description: "Internship Payment",
        image: "/tm logo.png",
        order_id,
        handler: async function (response) {
          const verifyRes = await fetch(
            `${config.BASE_URL}${config.INTERN_VERIFY_PAYMENT}`,
            {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              credentials: "include",
              body: JSON.stringify({
                ...response,                       
                intern_id: internshipDetails.intern_id,
                name: internshipDetails.name,
                domain: internshipDetails.domain,
                amount: amount
              }),
            }
          );

          const verifyData = await verifyRes.json();
          if (verifyData.status) {
            setMessage(" Payment successful!");
          } else {
            setMessage(" Payment verification failed");
          }
        },
       prefill: {
    name: username || "User", 
    email: userEmail || "customer@example.com", 
    contact: internshipDetails?.mobile || "9999999999", 
  },
  theme: { color: "#0a7cff" },
      };

      const razorpay = new window.Razorpay(options);
      razorpay.open();
    } catch (err) {
      console.error("Payment error:", err);
      setMessage("Something went wrong. Please try again.");
    }
  };

  const checkSlot = async () => {
    try {
      const res = await fetch(`${config.BASE_URL}${config.GET_SLOT_DETAILS}`, {
        method: "POST",
        credentials: "include"
      });
      const data = await res.json();

      if (data.success) {
        if (data.status === "in_process") {
          setPaymentDone(true);
          setSlotDetails(null);
        } else if (data.status === "allocated") {
          setPaymentDone(true);
          setSlotDetails(data.slot);
        }
      }
    } catch (err) {
      console.error("Error checking slot:", err);
    }
  };

  // Render main content
  const renderContent = () => {
    if (activeTab === "address") {
      return (
        <>
          {[1, 2].map(num => {
            const slot = num === 1 ? "address1" : "address2";
            const label = num === 1 ? "Shipping Address" : "Billing Address";
            return (
              <div key={num} className="address-block">
                {!addresses[slot] && editingAddress !== num && (
                  <button className="add-address-btn" onClick={() => setEditingAddress(num)}>
                    + Add {label}
                  </button>
                )}
                {editingAddress === num ? (
                  <form className="address-form" onSubmit={handleSave}>
          <h3>{addresses[slot] ? "Edit" : "Add"} {label}</h3>

          <div className="form-row">
            <label htmlFor={`fullname-${num}`}>Full Name</label>
            <input
              id={`fullname-${num}`}
              type="text"
              name="fullname"
              placeholder="Enter your full name"
              className="form-input"
              value={formData.fullname}
              onChange={handleChange}
              required
            />
            {formErrors.fullname && (
            <p className="error-message">{formErrors.fullname}</p>
          )}
          </div>

          <div className="form-row">
            <label htmlFor={`mobile-${num}`}>Mobile Number</label>
            <input
              id={`mobile-${num}`}
              type="text"
              name="mobile"
              placeholder="Enter mobile number"
              className="form-input"
              value={formData.mobile}
              onChange={handleChange}
              maxLength={10}       
          pattern="\d{10}"
              required
            />
            {formErrors.mobile && (
            <p className="error-message">{formErrors.mobile}</p>
          )}
          </div>

          <div className="form-row">
            <label htmlFor={`pincode-${num}`}>Pincode</label>
            <input
              id={`pincode-${num}`}
              type="text"
              name="pincode"
              placeholder="Enter pincode"
              className="form-input"
              value={formData.pincode}
              onChange={handleChange}
              maxLength={6}        
          pattern="\d{6}"
              required
            />
            {formErrors.pincode && <p className="error-message">{formErrors.pincode}</p>}
          </div>

          <div className="form-row">
            <label htmlFor={`flat-${num}`}>Flat / House No.</label>
            <input
              id={`flat-${num}`}
              type="text"
              name="flat"
              placeholder="Enter flat/house number"
              className="form-input"
              value={formData.flat}
              onChange={handleChange}
              required
            />
            {formErrors.flat && <p className="error-message">{formErrors.flat}</p>}
          </div>

          <div className="form-row">
            <label htmlFor={`area-${num}`}>Area / Street</label>
            <input
              id={`area-${num}`}
              type="text"
              name="area"
              placeholder="Enter area/street"
              className="form-input"
              value={formData.area}
              onChange={handleChange}
              required
            />
            {formErrors.area && <p className="error-message">{formErrors.area}</p>}
          </div>

          <div className="form-row">
            <label htmlFor={`landmark-${num}`}>Landmark</label>
            <input
              id={`landmark-${num}`}
              type="text"
              name="landmark"
              placeholder="Enter landmark"
              className="form-input"
              value={formData.landmark}
              onChange={handleChange}
              required
            />
            {formErrors.flat && <p className="error-message">{formErrors.flat}</p>}
          </div>

          <div className="form-row">
            <label htmlFor={`city-${num}`}>City</label>
            <input
              id={`city-${num}`}
              type="text"
              name="city"
              placeholder="Enter city"
              className="form-input"
              value={formData.city}
              onChange={handleChange}
              required
            />
            {formErrors.city && <p className="error-message">{formErrors.city}</p>}
          </div>

          <div className="form-row">
            <label htmlFor={`state-${num}`}>State</label>
            <input
              id={`state-${num}`}
              type="text"
              name="state"
              placeholder="Enter state"
              className="form-input"
              value={formData.state}
              onChange={handleChange}
              required
            />
            {formErrors.state && <p className="error-message">{formErrors.state}</p>}
          </div>

          <div className="form-row">
            <label htmlFor={`instructions-${num}`}>Delivery Instructions</label>
            <textarea
              id={`instructions-${num}`}
              name="instructions"
              placeholder="Enter any delivery instructions"
              className="form-input"
              value={formData.instructions}
              onChange={handleChange}
              required
            />
            {formErrors.instructions && <p className="error-message">{formErrors.instructions}</p>}
          </div>

          <div className="form-row checkbox">
            <input
              type="checkbox"
              name="default"
              id={`default-${num}`}
              checked={formData.default}
              onChange={handleChange}
            />
            <label htmlFor={`default-${num}`}>Set as default address</label>
          </div>

          <button type="submit" className="save-btn">
            Save 
          </button>
        </form>

                        ) : addresses[slot] ? (
                          <div className="saved-address">
                            <h3>{label}</h3>
                            <p>{addresses[slot]}</p>
                            <button className="edit-btn" onClick={() => setEditingAddress(num)}>Edit</button>
                          </div>
                        ) : null}
                      </div>
                    );
                  })}
                </>
              );
            }

if (activeTab === "internship" && (canAccessInternship || hasApplied)) {
  return (
    <>
    <div className="tab-internship-page">

      
      <div className="internship-status-steps">

        <div className={`step ${hasApplied ? "completed" : ""}`}>
          <span>1</span>
          Applied
        </div>

        <div className={`step ${canAccessInternship ? "completed" : ""}`}>
          <span>2</span>
          Selected
        </div>

        <div className={`step ${paymentDone ? "completed" : ""}`}>
          <span>3</span>
          Payment Received
        </div>

        <div className={`step ${slotDetails ? "completed" : ""}`}>
          <span>4</span>
          Payment Confirmed & Slot Allocated
        </div>

        <div className={`step ${isCompleted ? "completed" : ""}`}>
          <span>5</span> Completed
          </div>

      </div>

       {hasApplied && !canAccessInternship && (
        <div className="application-submitted">
          <h2>Your application has been submitted!</h2>
          <p>Please wait for the approval. Once selected, you will be notified here.</p>
        </div>
      )}


      {!paymentDone &&  canAccessInternship &&(
        <>
          <h2>Your internship is approved!</h2>
          <p>To continue, please proceed with the payment below.</p>
          <button className="proceed-payment-btn" onClick={() => setShowQR(true)}>
            Proceed to Payment
          </button>
        </>
      )}

      {paymentDone && !slotDetails && (
        <>
          <h2>Application in Process</h2>
          <p>Your payment has been received. Your internship slot will be allocated soon.</p>
        </>
      )}

 {isCompleted ? (
  <div className="internship-completed-section" style={{ marginTop: "20px", textAlign: "center" }}>
    <h3>🎉 Your internship is completed!</h3>
    <button
      className="download-certificate-btn"
      style={{
        padding: "10px 20px",
        backgroundColor: "#0a7cff",
        color: "white",
        border: "none",
        borderRadius: "8px",
        cursor: "pointer",
        fontWeight: "bold",
        marginTop: "10px"
      }}
      onClick={() => handleDownloadCertificate(internshipDetails.intern_id)}
    >
      Download Certificate
    </button>
  </div>
) : (
  paymentDone && slotDetails && (
    <div className="tab-internship-page">
      <h2>🎉 Slot Confirmed!</h2>
      <p>Your internship slot has been successfully allocated.</p>

      <div className="slot-info">
        <p><b>Slot No:</b> {slotDetails.slot_no}</p>
        <p><b>Domain:</b> {slotDetails.domain}</p>
        <p><b>Days:</b> {slotDetails.days}</p>
        <p><b>Timings:</b> {slotDetails.timings}</p>
      </div>
    </div>
  )
)}
    </div>

        <div style={{ marginTop: "40px" }}>
          <AssignmentSubmit />
        </div>

      </>
  );
}


    return <p>Content not available.</p>;
  };

  return (
    <div className="acc-dashboard-container">
      <header className="acc-dashboard-header">
        <h1>{loading ? "Loading..." : `Hello ${username || "User"}`}</h1>
      </header>

      <div className="acc-dashboard-layout">
        <aside className="acc-sidebar">
          <h2>Account</h2>
          <a onClick={() => setActiveTab("address")}>My Address</a>
          {(canAccessInternship || hasApplied)&& (
            <a onClick={() => setActiveTab("internship")}>Internship</a>
          )}
          <a onClick={() =>setShowLogoutConfirm(true)} className="logout-btn">
          Logout
        </a>

        </aside>

        <main className="acc-main-content">{renderContent()}</main>
      </div>

            {showLogoutConfirm && (
  <div 
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
      background: "rgba(0,0,0,0.5)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 2000,
    }}
  >
    <div 
      style={{
        background: "white",
        padding: "20px 30px",
        borderRadius: "12px",
        maxWidth: "400px",
        textAlign: "center",
        boxShadow: "0 6px 20px rgba(0,0,0,0.3)"
       
      }}
    >
      <h3 style={{ marginBottom: "15px" }}>Hello, Human!</h3>
      <p style={{ marginBottom: "20px" }}>Logging out will end our connection. Proceed?</p>
      
      <div style={{ display: "flex", justifyContent: "space-around" }}>
        <button 
          className="premium-glass-button" 
          style={{ color: "black" }}
          onClick={() => setShowLogoutConfirm(false)}
        >
          Cancel
        </button>
        <button 
          className="premium-glass-button" 
          style={{ color: "black" }}
          onClick={() => {
            handleLogout();
            setShowLogoutConfirm(false);
          }}
        >
          Yes, Logout
        </button>
      </div>
    </div>
  </div>
)}
      {message && (
        <div
          style={{
            position: "fixed",
            top: "50px",
            left: "50%",
            transform: "translateX(-50%)",
            padding: "15px 20px",
            borderRadius: "12px",
            background: "rgba(255,255,255,0.15)",
            backdropFilter: "blur(10px)",
            WebkitBackdropFilter: "blur(10px)",
            boxShadow: "0 4px 20px rgba(0,0,0,0.2)",
            color: "black",
            fontSize: "14px",
            fontWeight: "500",
            zIndex: 1000,
            minWidth: "250px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center"
          }}
        >
          <span>{message}</span>
          <span
            style={{ marginLeft: "15px", cursor: "pointer" }}
            onClick={() => setMessage(null)}
          >
            ×
          </span>
        </div>
      )}


      {showQR && (
  <div 
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
      background: "rgba(0,0,0,0.6)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 3000
    }}
  >
    <div
      style={{
        background: "white",
        padding: "25px",
        width: "350px",
        borderRadius: "14px",
        textAlign: "center",
        boxShadow: "0 10px 35px rgba(0,0,0,0.3)"
      }}
    >
      <h2 style={{ marginBottom: "10px" }}>Scan & Pay</h2>
      <img 
        src="/qr.png"
        alt="QR"
        style={{ width: "200px", display: "block", margin: "0 auto" }}
      />
      {amount !== null && (
  <p style={{
        marginTop: "12px",
        fontSize: "15px",
        fontWeight: "600",
        color: "#222",
        textAlign: "center"
  }}>
    Amount: ₹{amount}
  </p>
)}

      <p style={{ marginTop: "15px", fontSize: "14px", color: "#444" }}>
        After payment, enter the Transaction ID
      </p>

      <input
        type="text"
        placeholder="Enter Transaction ID"
        value={transactionId}
        onChange={(e) => setTransactionId(e.target.value)}
        style={{
          width: "100%",
          padding: "10px",
          marginTop: "10px",
          borderRadius: "8px",
          border: "1px solid #ccc"
        }}
      />

      <button
        style={{
          marginTop: "15px",
          width: "100%",
          padding: "10px",
          background: "#0a7cff",
          color: "white",
          border: "none",
          borderRadius: "8px",
          cursor: "pointer",
          fontWeight: "bold"
        }}
        onClick={handlePaymentConfirmation}
      >
        Confirm Payment
      </button>

      <button
        style={{
          marginTop: "10px",
          width: "100%",
          padding: "10px",
          background: "#ddd",
          border: "none",
          borderRadius: "8px",
          cursor: "pointer"
        }}
        onClick={() => setShowQR(false)}
      >
         Cancel
        </button>
       </div>
      </div>
       )}

 {isLoading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999
          }}
        >
          <Loading1 />
        </div>
      )}


    </div>
  );
};

export default Dashboard;

